import React from 'react'
import ReactDOM from 'react-dom'
import { Vector } from 'common/components'
import Agreement from 'common/static/agreement.html'
import Conditions from 'common/static/conditions.html'


export class License extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            window.document.addEventListener('click', this.onDocumentClick)
        }, 0)
    }

    componentWillUnmount() {
        window.document.removeEventListener('click', this.onDocumentClick)
    }

    onDocumentClick = (ev) => {
        const element = ReactDOM.findDOMNode(this.element);
        if (element && !element.contains(ev.target)) {
            this.props.onChange(null)
        }
    }


    render() {
        const text = { __html: `${Agreement}\n\n${Conditions}` };
        const onChange = this.props.onChange || (() => {});

        return (
            <div className="agreement__wrap" onClick={this.onDocumentClick}>
                <div className="agreement__item">
                    <div className="agreement__header">
                        <span style={{ textAlign: 'left' }}>
                            Для створення Київ ID Потрібно надати згоду на обробку
                            персональних даних та прийняти умови користування сервісом
                        </span>
                    </div>

                    <div className="agreement__item-wrap">
                        <div dangerouslySetInnerHTML={text} />
                    </div>

                    <div className="agreement__footer">
                        <button className="agreement__cancel" onClick={() => onChange(false)}>
                            Скасувати
                        </button>
                        <button className="agreement__submit" onClick={() => onChange(true)}>
                            Надаю згоду
                        </button>
                    </div>
                    <a className="is-clicklable agreement__close" onClick={() => onChange(null)}>
                        <Vector src="cancel-icon" alt="close-icon" />
                    </a>
                </div>
            </div>
        )
    }
}
